module.exports = __webpack_public_path__ + "static/media/award5@2x.2853b6c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_120/imgs/award5@2x.png
// module id = 1128
// module chunks = 0